import { TGetLiferayQuickAccessContentResponse } from './types';

export const formatQuickAccessContentResponse = (response: TGetLiferayQuickAccessContentResponse) => {
  const title = response.items[0].contentFields[0].contentFieldValue.data;
  const list = response.items[0].contentFields.slice(1).map((field) => {
    return {
      label: field.nestedContentFields?.[0].contentFieldValue.data,
      link: field.nestedContentFields?.[1].contentFieldValue.data,
      image: field.nestedContentFields?.[2].contentFieldValue.image?.contentUrl,
    };
  });
  return { title, list };
};
